import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const canUseShippingOptionMetafields = {
  name: "canUseShippingOptionMetafields" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ canUse: z.boolean(), reasons: z.array(z.string()) }),
};
